import { Heart, X } from 'lucide-react';

interface FavoritesPanelHeaderProps {
  totalCount: number;
  onClose: () => void;
}

export function FavoritesPanelHeader({ totalCount, onClose }: FavoritesPanelHeaderProps) {
  return (
    <div className="flex items-center justify-between p-4 border-b border-slate-100 bg-white sticky top-0 z-10">
      <div className="flex items-center gap-3">
        <div className="bg-red-50 p-2 rounded-full">
          <Heart size={20} className="text-red-500" fill="currentColor" />
        </div>
        <div>
          <h2 className="font-bold text-slate-800 text-lg">My Favorites</h2>
          <p className="text-xs text-slate-500">
            {totalCount} {totalCount === 1 ? 'item' : 'items'} saved
          </p>
        </div>
      </div>
      <button
        onClick={onClose}
        className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors"
        aria-label="Close favorites"
      >
        <X size={24} />
      </button>
    </div>
  );
}
